import React from "react";

export default class MembershipPrice extends React.Component {
  render() {
    return <div className="membership-price">{this.props.price}</div>;
  }
}
